export default {
  Actions: {
    FETCH_FEEDBACKS_SUCCESS: 'feedbacks/FETCH_FEEDBACKS_SUCCESS',
    FETCH_SINGLE_FEEDBACK_SUCCESS: 'feedbacks/FETCH_SINGLE_FEEDBACK_SUCCESS',
    DESTROY_FEEDBACK_REQUEST: 'feedbacks/DESTROY_FEEDBACK_REQUEST',
    DESTROY_FEEDBACK_FAILURE: 'feedbacks/DESTROY_FEEDBACK_FAILURE',
    CREATE_FEEDBACK_REQUEST: 'feedbacks/CREATE_FEEDBACK_REQUEST',
    CREATE_FEEDBACK_SUCCESS: 'feedbacks/CREATE_FEEDBACK_SUCCESS',
    CREATE_FEEDBACK_FAILURE: 'feedbacks/CREATE_FEEDBACK_SUCCESS',
    UPDATE_FEEDBACK_REQUEST: 'feedbacks/UPDATE_FEEDBACK_REQUEST',
    UPDATE_FEEDBACK_SUCCESS: 'feedbacks/UPDATE_FEEDBACK_SUCCESS',
    UPDATE_FEEDBACK_FAILURE: 'feedbacks/UPDATE_FEEDBACK_FAILURE',
    VIEW_FEEDBACK_SUCCESS: 'feedbacks/VIEW_FEEDBACK_SUCCESS',
    FEEDBACKS_SYNC_SUCCESS: 'feedbacks/FEEDBACKS_SYNC_SUCCESS',
    FEEDBACKS_FETCH_AI_SUGGESSTIONS_SUCCESS: 'feedbacks/FEEDBACKS_FETCH_AI_SUGGESSTIONS_SUCCESS',
  },
};
